import type React from "react";
import { ReactComponent as Svg } from "./assets/closing.svg";
import * as styles from "./Icon.module.scss";

type ClosingProps = React.SVGProps<SVGSVGElement>;

export const Closing = ({ className, ...props }: ClosingProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
